var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAni10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91637 7.64531V1.41731C9.96197 1.00611 10.1892 0.741308 10.598 0.622908C11.0068 0.502908 11.4116 0.606908 11.8124 0.934908L21.5156 9.14051C21.642 9.24496 21.7436 9.37627 21.8129 9.52489C21.8822 9.67352 21.9176 9.83572 21.9164 9.99971C21.9164 10.3357 21.7828 10.6229 21.5156 10.8613L11.7476 19.1221C11.3476 19.3989 10.9556 19.4809 10.5716 19.3681C10.1876 19.2553 9.96917 19.0101 9.91637 18.6325V12.3469L1.97957 19.0645C1.58277 19.3813 1.16437 19.4825 0.724369 19.3681C0.285169 19.2537 0.0715691 19.0085 0.0835691 18.6325V1.51571C0.0715691 1.12131 0.251969 0.836508 0.624769 0.661308C0.998369 0.485308 1.42637 0.554108 1.90877 0.867708L9.91637 7.64531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni10);
export default __webpack_public_path__ + "static/media/Ani10.7ed8375ed3f5636d9d8ababb35ae2946.svg";
export { ForwardRef as ReactComponent };